var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buyer"},[_c('cHeaderBuyer',{attrs:{"activeNav":"buyer"}}),_c('div',{staticClass:"body"},[_c('div',{staticClass:"page-wrap"},[_c('cBuyerMenu'),_c('router-view')],1)]),_c('cFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }